/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `BOL` - Original Bill Of Lading
 * * `SWB` - Seaway Bill
 */
export type BillTypeEnum = typeof BillTypeEnum[keyof typeof BillTypeEnum];


export const BillTypeEnum = {
  BOL: 'BOL',
  SWB: 'SWB',
} as const;
